import { type FC, type MouseEventHandler, type ReactNode } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';
import { useBuyerIncentivesMessages } from 'dibs-buyer-incentives/exports/useBuyerIncentivesMessages';
import { usePdpReturnsClientVariant } from '../../hooks/usePdpReturnsClientVariant';

import dibsCss from 'dibs-css';

const Incentives: FC = () => {
    const incentives = useBuyerIncentivesMessages();
    const isPdpReturnsClientVariant = usePdpReturnsClientVariant();

    return (
        <>
            {incentives.map((incentive, index) => (
                <div
                    key={index}
                    className={classnames(
                        isPdpReturnsClientVariant ? dibsCss.inline : dibsCss.inlineBlock,
                        dibsCss.whitespacePreWrap
                    )}
                >
                    <FormattedMessage
                        id="PdpSharedSidebarBuyerIncentives.incentive"
                        defaultMessage="{isLast, select, true {{incentive}} other {{incentive}, }}"
                        values={{ incentive, isLast: index === incentives.length - 1 }}
                    />
                </div>
            ))}
        </>
    );
};

const PdpSharedSidebarBuyerIncentives: FC<{
    onDetailsClick?: MouseEventHandler;
}> = ({ onDetailsClick }) => {
    const showLink = !!onDetailsClick;

    const getLink = (chunk: ReactNode): ReactNode => {
        if (showLink) {
            return <Link onClick={onDetailsClick}>{chunk}</Link>;
        } else {
            return null;
        }
    };

    return (
        <span>
            <FormattedMessage
                id="PdpSharedSidebarBuyerIncentives.incentives.copy"
                defaultMessage="<strong>The 1stDibs Promise:</strong> {incentives} <link>Details</link>"
                values={{
                    strong: chunk => <strong>{chunk}</strong>,
                    incentives: <Incentives />,
                    link: chunk => getLink(chunk),
                }}
            />
        </span>
    );
};

export default PdpSharedSidebarBuyerIncentives;
